type ScoreboardRow = { name?: unknown; value?: unknown };

const REDUCED_ROWS = ["reduced1", "reduced2", "reduced_match"];

/**
 * True when Decimal flags a rain-reduced innings/match (factor below 1). The feed carries no
 * revised (DLS) target, so "runs.1 + 1" is not the real target once this is set.
 * Returns null when the scoreboard carries none of the factors.
 */
export function scoreboardOversReduced(scoreboard: unknown): boolean | null {
  if (!Array.isArray(scoreboard)) return null;
  let seen = false;
  for (const name of REDUCED_ROWS) {
    const row = (scoreboard as ScoreboardRow[]).find((r) => r?.name === name);
    const raw = row?.value;
    if (raw == null || String(raw).trim() === "") continue;
    const n = Number(raw);
    if (!Number.isFinite(n)) continue;
    seen = true;
    if (n > 0 && n < 1) return true;
  }
  return seen ? false : null;
}
